import { API_BASE, apiFetch } from "./apiBase";

export type DemoRequestPayload = {
  name: string;
  email: string;
  company?: string;
  message?: string;
  company_website?: string;
  form_started_at: number;
  page_url?: string;
};

export async function submitDemoRequest(payload: DemoRequestPayload): Promise<void> {
  const res = await apiFetch(`${API_BASE}/demo-request`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const text = await res.text();
    let message = "Unable to send request.";
    try {
      const parsed = JSON.parse(text) as { error?: string };
      if (parsed.error) message = parsed.error;
    } catch {
      if (text) message = text;
    }
    throw new Error(message);
  }
}
